import React, { useContext, useState } from "react";
import { Card, CardContent, Button, Grid } from "@mui/material";
import { AxiosContext } from "../../../app/assets/axios/admin/AxiosComponent";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { postCreateForm } from "../../../actions/admin/actionCreators";
import CollapsedBreadcrumbs, { BreadcrumbsContext } from "../../../layouts/admin/breadcrumb";

import TextFieldComponent from "../../FormAddInputComponent/TextField";
import SelectOptionComponent from "../../FormAddInputComponent/SelectOption";
import { AppBarSpacer, CardHeaderCss } from "../../../css/Admin-css/listing-css";

export default function CountryCreate() {
    const { enqueueSnackbar } = useSnackbar();
    const {
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = useForm({
        mode: "all",
    });

    const api = useContext(AxiosContext);
    const navigate = useNavigate();

    const onSubmit = handleSubmit(async (data) => {
        const response = await postCreateForm({
            api: api,
            data: data,
            method: "POST",
            url: "createCountry",
            enqueueSnackbar,
        });

        if (response) {
            if (response.data.status === 200) {
                enqueueSnackbar(response.data.msg_title, {
                    variant: "success",
                    anchorOrigin: {
                        vertical: "top",
                        horizontal: "center",
                    },
                });
                navigate("/admin/country-list");
            }
        }
    });

    const statusList = [
        { id: "A", name: "Active" },
        { id: "I", name: "Inactive" },
    ];

    const [breadcrumbArr, setBreadcrumbArr] = React.useState([
		{
			text: "Country",
			link: "/admin/country-list",
		}, 
		{
			text: "Country Form",
			link: "/admin/country/create",
		}, 
	]);

    const [status, setStatus] = useState("");

    const onSelectChangeHandler = (name) => (event) => {
        const value = event.target.value;
        if (name == "status") {
            setStatus(value);
        }
        setValue(name, value);
    };

    return (
        <>
            <BreadcrumbsContext.Provider value={[breadcrumbArr, setBreadcrumbArr]} >
				<CollapsedBreadcrumbs />
			</BreadcrumbsContext.Provider>
            <Card>
                <CardHeaderCss title="Create Country"/>
                <CardContent>
                    <form>
                    <Grid container spacing={2}>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="code"
                                    marginType="normal"
                                    label="Code"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="name"
                                    marginType="normal"
                                    label="Name"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="size_nsn"
                                    placeholder="Single Number or Range like (9 or 9,13)"
                                    marginType="normal"
                                    label="NSN Length"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        pattern: {
                                            value: /^[-,0-9]+$/i,
                                            message: "invalid NSN Length, Single Number or Range like (9 or 9,13)"
                                        }
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <TextFieldComponent
                                    control={control}
                                    name="prefix_calling_code"
                                    placeholder="Single Number like (60)"
                                    marginType="normal"
                                    label="Calling Codes"
                                    type="text"
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                        pattern: {
                                            value: /^[0-9]+$/i,
                                            message: "invalid Calling Codes, Single Number like (60)"
                                        }
                                    }}
                                    errors={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} style={{ paddingTop: 0 }}>
                                <SelectOptionComponent
                                    control={control}
                                    name="status"
                                    placeholder="Status"
                                    label="Status"
                                    option={statusList}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: "This field is required",
                                        },
                                    }}
                                    errors={errors}
                                    onChangeHandler={onSelectChangeHandler("status")}
                                    value={status}
                                />
                            </Grid>
                        </Grid>
                        <AppBarSpacer />
                        <div align="center">
                            <Button
                                variant="contained"
                                color="primary"
                                type="submit"
                                onClick={onSubmit}
                                size="large"
                            >
                                Submit
                            </Button>
                        </div>
                    </form>
                </CardContent>
            </Card>
        </>
    );
}
